import { render, staticRenderFns } from "./SectionAgencyLegalInformationDate.vue?vue&type=template&id=4cc1180b&"
import script from "./SectionAgencyLegalInformationDate.vue?vue&type=script&lang=js&"
export * from "./SectionAgencyLegalInformationDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports